import * as ko from "knockout";
import * as _ from "underscore";
import { App } from "../app";
import { Api } from "../app-api";
import { Cart } from "../app-cart";
import { ModeEnum } from "../app-models";

const divRoot: HTMLDivElement = document.querySelector("#ko-edit");
const divModel: HTMLDivElement = document.querySelector("#divAccountEditModel");

export class ViewModel {
    id: number;
    regions: any;
    mode: ModeEnum;

    busy = ko.observable<boolean>();

    email = ko.observable<string>();
    confirmEmail = ko.observable<string>();
    firstName = ko.observable<string>();
    lastName = ko.observable<string>();
    phone1 = ko.observable<string>();
    phone2 = ko.observable<string>();
    street1 = ko.observable<string>();
    street2 = ko.observable<string>();
    city = ko.observable<string>();
    postal = ko.observable<string>();
    password = ko.observable<string>();
    confirmPassword = ko.observable<string>();

    editingEmail = ko.observable(false);
    enableEmail = ko.observable(false);
    selectedRegion = ko.observable<number>();

    cart = ko.observable<Cart>(); // timer

    //showPrivacy: () => void;
    submit: () => void;

    constructor(model) {
        let self = this;

        let data = JSON.parse(model);

        self.mode = data.customer ? ModeEnum.Edit : ModeEnum.Add;
        self.regions = self.regionOptions(data.regions);

        if (self.mode === ModeEnum.Edit)
            self.edit(data.customer);
        else
            self.enableEmail(true);

        if (data.cart) { self.cart(new Cart(data.cart, data.returnUrl)); }

        self.busy.subscribe(newVal => App.busy(newVal));

        self.email.subscribe(newVal => {
            if (self.mode === ModeEnum.Add &&
                App.hasVal(newVal) &&
                newVal.length > 0) { self.uniqueEmail(); }
        });

        //self.showPrivacy = () => {
        //    Api.GetPrivacyPolicyInfo()
        //        .done(results => {
        //            App.showInfo(results, "Privacy Policy");
        //        });
        //}

        self.submit = () => {
            if (!self.busy())
                self.save();
        }
    }

    private edit(customer) {
        let self = this;

        self.id = customer.id;
        self.email(customer.email);
        self.firstName(customer.firstName);
        self.lastName(customer.lastName);
        self.phone1(customer.phone1);
        self.phone2(customer.phone2);
        self.street1(customer.street1);
        self.street2(customer.street2);
        self.city(customer.city);
        self.postal(customer.postal);

        self.selectedRegion(customer.region);
    }

    private uniqueEmail() {
        let self = this;

        self.busy(true);

        let data = {
            value: self.email()
        };

        Api.UniqueEmail(data)
            .done(results => {
                if (results.error) { return App.alertError(results.message); }

                if (!App.isValid(results.valid))
                {
                    //self.email("");
                    self.editingEmail(true);
                    return App.alertWarning(results.message);
                }
            })
            .always(() => self.busy(false));
    }

    private toJson() {
        let self = this;

        let data = {
            id: self.id,
            email: self.mode === ModeEnum.Add ? {
                value: self.email(),
                confirm: self.confirmEmail()
            } : null,
            firstName: self.firstName(),
            lastName: self.lastName(),
            phone1: self.phone1(),
            phone2: self.phone2(),
            street1: self.street1(),
            street2: self.street2(),
            city: self.city(),
            region: self.selectedRegion(),
            postal: self.postal(),
            password: self.mode === ModeEnum.Add ? {
                value: self.password(),
                confirm: self.confirmPassword()
            } : null
        }

        return data;
    }

    private regionOptions(regions) {
        let results = [];

        // regions grouped by country
        _(regions).each(x =>
        {
            results.push({ text: "--- " + x.country + " ---" });
            _(x.regions).each(y => results.push({ value: y.id, text: y.name }));
        });

        return results;
    }

    private save() {
        let self = this;

        self.busy(true);

        let data = self.toJson();

        Api.SaveAccount(data)
            .done(results => {
                if (results.error) { return App.alertError(results.message); }
                if (!App.isValid(results.valid)) { return App.alertWarning(results.message); }
                window.location.href = results.nextUrl;
            })
            .always(() => self.busy(false));
    }
}

function init() {
    if (divModel) {
        ko.applyBindings(new ViewModel(divModel.textContent), divRoot);
    }
}

$(document).ready(() => init());